var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid05IconDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.615,
    height: 25,
    viewBox: "0 0 25.615 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#818ca4;}.b{fill:#3acce1;}.c{fill:#fff;font-size:10px;font-family:Roboto-Bold, Roboto;font-weight:700;letter-spacing:-0.1em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.385 -291)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.614,3H21.275a3.609,3.609,0,0,1,3.614,3.614V22.275a3.609,3.609,0,0,1-3.614,3.614H5.614A3.609,3.609,0,0,1,2,22.275V6.614A3.609,3.609,0,0,1,5.614,3m0,1.2A2.416,2.416,0,0,0,3.2,6.614v3.614H9.228V4.2H5.614M3.2,22.275a2.416,2.416,0,0,0,2.409,2.409H9.228V18.661H3.2v3.614M9.228,11.433H3.2v6.023H9.228V11.433M21.275,24.684a2.416,2.416,0,0,0,2.409-2.409V18.661H17.661v6.023h3.614m2.409-13.251H17.661v6.023h6.023V11.433m0-4.819A2.416,2.416,0,0,0,21.275,4.2H17.661v6.023h6.023V6.614M10.433,4.2v6.023h6.023V4.2H10.433m0,20.479h6.023V18.661H10.433v6.023m6.023-13.251H10.433v6.023h6.023Z",
    transform: "translate(51.385 288)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 15,
    rx: 7.5,
    transform: "translate(62 301)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(64 312)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0.5"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid05IconDefault);
export default __webpack_public_path__ + "static/media/grid05IconDefault.c07802900ae7cc36bc2912496c3b43ad.svg";
export { ForwardRef as ReactComponent };